import React, { Component } from "react";
import { encryptData } from "./utils/encryptionUtils";
import { getClientId } from "./utils/analyticsclientIdUtils";

import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

import { Redirect_Url_2 } from "./ZPartnerLSCUrls";

import { validatePassword, validatePasswordTH, validateNameEN, validateNameENTH, validateLastnameEN, validateLastnameENTH } from './utils/validatePassword';

export class LSC_JoinNowAction20 extends Component {
    static displayName = LSC_JoinNowAction20.name;

    constructor(props) {

        super(props);

        this.otpInputRefs = [];

        this.state = {
            message: "",
            loginstatus: "",
            submitting: false,
            actionid: "",

            email: "",
            Password: "",
            ConfirmPassword: "",
            registerMsgPwd: '',
            registerMsgPwd2: '',
            registerMsgFname: '',
            registerMsgLname: '',
            registerMsgMobile: '',
            Salutation: "",
            Name: "",
            Lastname: "",
            NameTH: "",
            LastnameTH: "",
            mobile: "",
            BirthdayD: "",
            BirthdayM: "",
            Terms01: false,
            Terms02: false,
            showPassword: false,
            showConfirmPassword: false,
            showPasswordHint: false,
            showBirthdayModal: false,
            isLoading: true,
            currentStep: '1',//SR2.0 param start here
            disabledBtnOtp: true,
            disabledBtnSubmit: true,
            languagePreference: '',
            receiveNews: false,
            receiveNewsSMS: false,
            receiveNewsEmail: false,
            receiveNewsCss: 'mb-3 ps-0 d-none',
            showOtpModal: false,//OTP Modal
            otpValues: ['', '', '', '', '', ''],
            otpTimeLeft: 60,
            otpCanResend: false,
            otpRefCode: '',
            otpMessage: '',
            otpTimerId: null,
            mobileVerified: false,
            otpRunId: '',
            otpMaxError: false,
            registerMsgLanguage: '',
            registerMsgReceive: '',
            registerMsgAgree: '',
            showPopup: false,//BD Modal
            cssBtnOtpCurrent: 'btn btn-gray rounded-pill px-4 text-decoration-none ms-3',
            cssBtnOtp01: 'btn btn-gray rounded-pill px-4 text-decoration-none ms-3',
            cssBtnOtp02: 'btn btn-primary rounded-pill px-4 text-decoration-none ms-3',
            cssBtnSubmitCurrent: 'btn btn-gray rounded-pill px-4 text-decoration-none',
            cssBtnSubmit01: 'btn btn-gray rounded-pill px-4 text-decoration-none',
            cssBtnSubmit02: 'btn btn-primary rounded-pill px-4 text-decoration-none',
            cssEmailUsername: 'fw-semibold text-green-1',
        };
    }

    fetchPreload = async (actionid) => {
        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            ActionId: actionid,
            RefLang: "en",
            Timestamp: timestamp
        };

        const encryptedPayload = encryptData(payload);

        try {
            const response = await fetch("/api/ZPartnerLSCJoinnowStep02", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
            });

            const data = await response.json();

            if (data.responseCode === "00") {
                const email = data.email || "";
                let cssEmailUsername = "fw-semibold text-green-1";

                if (email.length > 50) {
                    cssEmailUsername = "fw-semibold text-green-1 h6 small";
                } else if (email.length > 25) {
                    cssEmailUsername = "fw-semibold text-green-1 h6";
                }

                this.setState({
                    email,
                    cssEmailUsername: cssEmailUsername,
                    isLoading: false // set isLoading for complete loading
                });
            } else {
                sessionStorage.setItem("lscErrorMsg", "Error when loading data");
                window.location.replace("/line_err01");
            }
        } catch (error) {
            console.error("Preload error:", error);
            sessionStorage.setItem("lscErrorMsg", "System error");
            window.location.replace("/line_err01");
        }
    };


    componentDidMount() {
        //const links = [
        //    "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
        //    "/css/lsc/style_01.css",
        //    "/css/lsc/style_02.css",
        //    "/css/lsc/style_03.css",
        //    "/css/lsc/691208892_en-US.css",
        //    "/css/lsc/line_my_card.css"
        //];

        //links.forEach(href => {
        //    const link = document.createElement("link");
        //    link.rel = "stylesheet";
        //    link.href = href;
        //    document.head.appendChild(link);
        //});

        // Read query string parameters
        const params = new URLSearchParams(window.location.search);
        const actionid = params.get("actionid");
        // If any required parameter is missing, redirect to error page
        if (!actionid) {
            sessionStorage.setItem("lscErrorMsg", "Missing param action!!");
            window.location.replace("/line_err01");
            return;
        }

        this.setState({
            actionid: actionid
        });

        // check actionid is exists
        this.fetchPreload(actionid);

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "LSC_Joinnow_Action";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        // #region "back button / history handling"
        if (typeof window !== "undefined" && window.history && window.history.pushState) {
            // keep reference for removeEventListener later
            this.handlePopState = () => {
                const hashLocation = window.location.hash;
                const hashSplit = hashLocation.split("#!/");
                const hashName = hashSplit[1];

                if (hashName !== "") {
                    const hash = window.location.hash;
                    if (hash === "") {
                        window.location = Redirect_Url_2;
                        return false;
                    }
                }
            };

            window.addEventListener("popstate", this.handlePopState);

            // same as original: push fake state into history
            window.history.pushState("forward", null, "./#forward");
        }
        // #endregion
    }

    componentWillUnmount() {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }

        this.otpInputRefs = [];

        if (this.handlePopState) {
            window.removeEventListener("popstate", this.handlePopState);
        }
    }

    handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        // checkbox
        if (type === "checkbox") {
            //if (name === "receiveNews") {
            //    let css01 = 'mb-3 ps-0 d-none';
            //    if (checked) {
            //        css01 = 'mb-3 ps-0';
            //    }

            //    this.setState(
            //        { [name]: checked, receiveNewsCss: css01 },
            //        () => this.chkEnableBtnSubmit()
            //    );
            //}
            //else {
            //    this.setState(
            //        { [name]: checked },
            //        () => this.chkEnableBtnSubmit()
            //    );
            //}

            if (name === "receiveNews") {
                let css01 = "mb-3 ps-0 d-none";

                if (checked) {
                    css01 = "mb-3 ps-0";

                    this.setState(
                        {
                            receiveNews: true,
                            receiveNewsCss: css01
                        },
                        () => this.chkEnableBtnSubmit()
                    );
                } else {
                    this.setState(
                        {
                            receiveNews: false,
                            receiveNewsCss: css01,
                            receiveNewsSMS: false,
                            receiveNewsEmail: false
                        },
                        () => this.chkEnableBtnSubmit()
                    );
                }
            } else {
                this.setState(
                    { [name]: checked },
                    () => this.chkEnableBtnSubmit()
                );
            }

            return;
        }

        // radio
        if (type === "radio") {
            this.setState(
                { [name]: value },
                () => this.chkEnableBtnSubmit()
            );
            return;
        }

        // text / number / other inputs
        let newValue = value;
        let errors = "";
        let errorsMobile = "";

        if (name === "mobile") {
            newValue = value.replace(/\D/g, "").slice(0, 10);
            errorsMobile = this.validateMobileNumber(newValue);
        }

        if (name === "Password") {
            let errorsTH = validatePasswordTH(newValue);
            let errorsEN = validatePassword(newValue);

            errors = (!errorsTH && !errorsEN)
                ? ""
                : errorsTH + " / " + errorsEN;
        }

        let disabledBtnOtp = this.state.disabledBtnOtp;
        let cssBtnOtpCurrent = this.state.cssBtnOtp01;
        if (name === "mobile") {
            if (errorsMobile !== "") {
                disabledBtnOtp = true;
                cssBtnOtpCurrent = this.state.cssBtnOtp01;
            } else {
                disabledBtnOtp = false;
                cssBtnOtpCurrent = this.state.cssBtnOtp02;
            }
        }

        const newState = {
            [name]: newValue,
            registerMsgPwd: errors,
            disabledBtnOtp: disabledBtnOtp,
            cssBtnOtpCurrent: cssBtnOtpCurrent
        };

        if (name === "BirthdayM") {
            newState.BirthdayD = "";
        }

        this.setState(newState, () => this.chkEnableBtnSubmit());
    };

    togglePasswordVisibility = () => {
        this.setState((prev) => ({
            showPassword: !prev.showPassword
        }));
    };

    toggleConfirmPasswordVisibility = () => {
        this.setState((prev) => ({
            showConfirmPassword: !prev.showConfirmPassword
        }));
    };

    handlePasswordFocus = () => {
        this.setState({ showPasswordHint: true });
    };

    handlePasswordBlur = () => {
        this.setState({ showPasswordHint: false });
    };

    closeBirthdayModal = () => {
        this.setState({ showBirthdayModal: false });
    };

    confirmSkipBirthday = () => {
        // User selects "No/Yes" -> closes modal then fires API.
        this.setState({ showBirthdayModal: false }, () => {
            this.submitToApi();
        });
    };

    goFillBirthday = () => {
        // User selects "Enter/No" -> close modal and focus on birthday.
        this.setState({ showBirthdayModal: false }, () => {
            const el = document.getElementById("BirthdayD");
            if (el) {
                el.focus();
            }
        });
    };

    validateMobileNumber = (mobile) => {
        const mobileRegex = /^0[0-9]{9}$/; // must start with 0 and total 10 digits

        if (!mobile || mobile.length === 0) {
            return 'เบอร์โทรศัพท์ไม่ถูกต้อง / Invalid mobile number.';
        }

        if (!mobileRegex.test(mobile)) {
            return 'เบอร์โทรศัพท์ไม่ถูกต้อง / Invalid mobile number.';
        }

        return ''; // valid
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ loginstatus: "", registerMsgPwd2: "", registerMsgFname: "", registerMsgLname: "", registerMsgMobile: "", registerMsgLanguage: "", registerMsgReceive: "", registerMsgAgree: "" });


        const {
            Name,
            Lastname,
            Password,
            ConfirmPassword,
            BirthdayD,
            BirthdayM,
            Terms01,
            Terms02,
            mobile, languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail, mobileVerified
        } = this.state;

        let canSubmit = true;

        if (!Name?.trim() ||
            !Lastname?.trim() ||
            !Password?.trim() ||
            !ConfirmPassword?.trim() ||
            Password !== ConfirmPassword) {
            this.setState({
                loginstatus: "กรุณาตรวจสอบข้อมูลให้ถูกต้องและครบถ้วน / Please check required information",
                submitting: false
            });
            canSubmit = false;
        }

        const errors = validatePassword(Password);
        if (errors) {
            this.setState({
                loginstatus: errors,
                submitting: false
            });
            canSubmit = false;
        }

        const errorsEn01 = validateNameEN(Name);
        const errorsEn03 = validateNameENTH(Name);
        if (errorsEn01) {
            this.setState({ registerMsgFname: errorsEn03 + " / " + errorsEn01, submitting: false });
            canSubmit = false;
        }

        const errorsEn02 = validateLastnameEN(Lastname);
        const errorsEn04 = validateLastnameENTH(Lastname);
        if (errorsEn02) {
            this.setState({ registerMsgLname: errorsEn04 + " / " + errorsEn02, submitting: false });
            canSubmit = false;
        }

        // Mobile validation
        if (mobile && (!/^0\d{9}$/.test(mobile))) {
            this.setState({ registerMsgMobile: "เบอร์โทรศัพท์ไม่ถูกต้อง / Invalid mobile number.", submitting: false });
            canSubmit = false;
        }

        // Mobile mobileVerified
        if (mobileVerified == false) {
            this.setState({ registerMsgMobile: "เบอร์โทรศัพท์ไม่ถูกต้อง / Invalid mobile number.", submitting: false });
            canSubmit = false;
        }

        if (languagePreference === "") {
            this.setState({ registerMsgLanguage: "กรุณาเลือกการตั้งค่าภาษา / Please select your language preference.", submitting: false });
            canSubmit = false;
        }

        // Only validate channels when user chooses to receive news
        if (receiveNews === true) {
            if (receiveNewsSMS === false && receiveNewsEmail === false) {
                this.setState({ registerMsgReceive: "กรุณาเลือกช่องทางที่คุณต้องการรับโปรโมชันและข่าวสารจากสตาร์บัคส์ / Please select channels you would like to receive Starbucks promotions and news." });
                canSubmit = false;
            }
        }        

        // Terms validation
        if (!Terms01) {
            this.setState({
                loginstatus:
                    "กรุณายอมรับเงื่อนไขและข้อตกลงก่อนทำรายการ / Please accept the terms of use",
                submitting: false
            });
            canSubmit = false;
        }

        // Terms02 if required
        // if (!Terms02) {
        //     this.setState({
        //         loginstatus: "Please accept marketing consent",
        //         submitting: false
        //     });
        //     return;
        // }

        if (canSubmit == false) {
            //unlock because validation failed
            this.setState({ disabledBtnSubmit: false });
            return;
        }

        // If the birth date or month is empty -> Open the Ask modal first.
        if (!BirthdayD || !BirthdayM) {
            this.setState({ showBirthdayModal: true });
            return;
        }        

        this.submitToApi();
    };

    submitToApi = async () => {
        const {
            actionid,
            Password,
            ConfirmPassword,
            Salutation,
            Name,
            Lastname,
            NameTH,
            LastnameTH,
            mobile,
            BirthdayD,
            BirthdayM,
            Terms01,
            Terms02,
            languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail
        } = this.state;

        // Prevent double submit
        this.setState({ submitting: true });
        document.body.classList.add("wait-cursor");

        const timestamp = Math.floor(Date.now() / 1000);

        const optInMarketing = receiveNews ? receiveNews : false;
        const optInSMS = receiveNews ? receiveNewsSMS : false;
        const optInEmail = receiveNews ? receiveNewsEmail : false;

        // Payload for api
        const payload = {
            ActionId: actionid,
            Password,
            ConfirmPassword,
            Salutation,
            Name,
            Lastname,
            NameTH,
            LastnameTH,
            Mobile: mobile,
            BirthdayD: BirthdayD === "" ? null : BirthdayD,
            BirthdayM: BirthdayM === "" ? null : BirthdayM,
            Terms01,
            Terms02,
            RefLang: "en",
            Timestamp: timestamp,
            LanguagePreference: languagePreference,
            OptInMarketing: optInMarketing, OptInSMS: optInSMS, OptInEmail: optInEmail //SR2.0
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/ZPartnerLSCJoinnowStep03SR20`, requestOptions);
            const data = await response.json();

            if (data.responseCode === "00") {
                const message = (data.responseMessage || "").toLowerCase();
                sessionStorage.setItem("signinMessage", message);

                document.body.classList.remove("wait-cursor");

                // Redirect after successful signin
                switch (message) {
                    case "success":
                        window.location.replace("/line_joinnow_success");
                        break;
                    case "error-failcreatecrmprofile":
                        sessionStorage.setItem("lscErrorMsg", "FailCreateCrmProfile");
                        window.location.replace("/line_err01");
                        break;
                    default:
                        window.location.replace("/");
                        break;
                }
            } else {
                document.body.classList.remove("wait-cursor");

                sessionStorage.setItem("lscErrorMsg", "Error occur !!");
                window.location.replace("/line_err01");
            }
        } catch (error) {
            console.error("Error during LineSignin API:", error);
            this.setState({
                loginstatus: "Unexpected error occurred",
                submitting: false
            });

            document.body.classList.remove("wait-cursor");
        }
    };

    //SR2.0
    async callApiSR20OtpStep01(mobile, codeRegister, Source, RefLang, LoyaltyMemberId) {
        document.body.classList.add('wait-cursor');

        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            codereg: codeRegister,
            RefLang: RefLang,
            Timestamp: timestamp,
            MobilePhone: mobile,
            Source: Source,
            LoyaltyMemberId: LoyaltyMemberId
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/SR20OtpStep01`, requestOptions);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('API call error :', error);
            return null;
        } finally {
            document.body.classList.remove('wait-cursor');
        }
    }

    async callApiSR20OtpStep02(mobile, codeRegister, Source, RefLang, LoyaltyMemberId, OtpId, RefCode, Otp) {
        document.body.classList.add('wait-cursor');

        const timestamp = Math.floor(Date.now() / 1000);

        const payload = {
            codereg: codeRegister,
            RefLang: RefLang,
            Timestamp: timestamp,
            MobilePhone: mobile,
            Source: Source,
            LoyaltyMemberId: LoyaltyMemberId,
            OtpId: OtpId,
            RefCode: RefCode,
            Otp: Otp
        };

        const encryptedPayload = encryptData(payload);

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Data: encryptedPayload, Timestamp: timestamp })
        };

        try {
            const response = await fetch(`/api/SR20OtpStep02`, requestOptions);
            const data = await response.json();

            return data;
        } catch (error) {
            console.error('API call error :', error);
            return null;
        } finally {
            document.body.classList.remove('wait-cursor');
        }
    }

    handleStep01 = async e => {
        e.preventDefault();

        //260120 block double submit
        //Guard: if already submitting, ignore
        if (this.state.submitting) return;
        //Lock immediately (prevents rapid clicks/enter)
        this.setState({ submitting: true });

        const { Password, ConfirmPassword } = this.state;
        let password1 = Password;
        let password2 = ConfirmPassword;

        {
            let canSubmit = true;

            //check form condition
            const errors = validatePassword(password1);
            const errorsTH = validatePasswordTH(password1);
            if (errors) {
                this.setState({ registerMsgPwd: errors + " / " + errorsTH });
                canSubmit = false;
            }

            if (password1 === "") {
                this.setState({ registerMsgPwd: "กรุณากรอกรหัสผ่าน / Please Input Password." });
                canSubmit = false;
            }

            if (password2 === "") {
                this.setState({ registerMsgPwd2: "กรุณากรอกยืนยันรหัสผ่าน / Please Input Confirm Password." });
                canSubmit = false;
            }

            if (password1 !== password2) {
                this.setState({ registerMsgPwd2: "รหัสผ่านที่คุณกรอกไม่ตรงกัน / The password confirmation does not match" });
                canSubmit = false;
            }

            if (canSubmit == false) {
                this.setState({ submitting: false });
                return;
            }
            else {
                this.setState({ currentStep: '2', submitting: false });
                return;
            }
        }


    };

    openOtpModal = async () => {
        const { mobile, otpTimerId, actionid } = this.state;

        const mobileError = this.validateMobileNumber(mobile);
        if (mobileError) {
            this.setState({
                registerMsgMobile: mobileError,
                showOtpModal: false
            });
            return;
        }

        if (otpTimerId) {
            clearInterval(otpTimerId);
        }

        // #region "call API Get OTP"
        const data = await this.callApiSR20OtpStep01(mobile, actionid, "Register", "3rd", "");

        if (data) {
            if (data.responseCode == "OK") {
                this.setState(
                    {
                        showOtpModal: true,
                        otpValues: ['', '', '', '', '', ''],
                        otpTimeLeft: 60,
                        otpCanResend: false,
                        otpMessage: '',
                        otpRefCode: data.returnObj.refCode,
                        otpRunId: data.returnObj.otpId,
                        otpMaxError: false,
                        registerMsgMobile: ''
                    },
                    () => {
                        this.startOtpTimer();

                        if (this.otpInputRefs[0]) {
                            this.otpInputRefs[0].focus();
                        }
                    }
                );
            } else {
                this.setState({ registerMsgMobile: data.responseMessage });
            }
        } else {
            this.setState({ registerMsgMobile: 'An unexpected error occurred on the server. Please try again.' });
        }
        // #endregion
    };

    closeOtpModal = () => {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }

        this.setState({
            showOtpModal: false,
            otpTimerId: null
        });
    };

    startOtpTimer = () => {
        if (this.state.otpTimerId) {
            clearInterval(this.state.otpTimerId);
        }

        const timerId = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.otpTimeLeft <= 1) {
                    clearInterval(timerId);
                    return {
                        otpTimeLeft: 0,
                        otpCanResend: true,
                        otpTimerId: null
                    };
                }

                return {
                    otpTimeLeft: prevState.otpTimeLeft - 1
                };
            });
        }, 1000);

        this.setState({ otpTimerId: timerId });
    };

    formatOtpTime = (sec) => {
        return `00:${String(sec).padStart(2, '0')}`;
    };

    //handleOtpChange = (index, event) => {
    //    const value = event.target.value.replace(/\D/g, '').slice(0, 1);

    //    this.setState((prevState) => {
    //        const newOtpValues = [...prevState.otpValues];
    //        newOtpValues[index] = value;
    //        return { otpValues: newOtpValues, otpMessage: '' };
    //    }, () => {
    //        if (value && index < 5 && this.otpInputRefs[index + 1]) {
    //            this.otpInputRefs[index + 1].focus();
    //        }
    //    });
    //};

    handleOtpChange = (index, event) => {
        const inputValue = event.target.value.replace(/\D/g, '');

        this.setState((prevState) => {
            const newOtpValues = [...prevState.otpValues];

            if (inputValue.length > 1) {
                const otpArray = inputValue.slice(0, 6).split('');

                otpArray.forEach((digit, i) => {
                    newOtpValues[i] = digit;
                });

                return { otpValues: newOtpValues, otpMessage: '' };
            }

            newOtpValues[index] = inputValue.slice(0, 1);

            return { otpValues: newOtpValues, otpMessage: '' };
        }, () => {
            if (inputValue.length > 1) {
                const lastIndex = Math.min(inputValue.length - 1, 5);
                this.otpInputRefs[lastIndex]?.focus();
            } else if (inputValue && index < 5 && this.otpInputRefs[index + 1]) {
                this.otpInputRefs[index + 1].focus();
            }
        });
    };

    handleOtpKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !this.state.otpValues[index] && index > 0) {
            if (this.otpInputRefs[index - 1]) {
                this.otpInputRefs[index - 1].focus();
            }
        }
    };

    handleOtpPaste = (event) => {
        event.preventDefault();

        const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);
        const newOtpValues = ['', '', '', '', '', ''];

        pasted.split('').forEach((char, i) => {
            newOtpValues[i] = char;
        });

        this.setState({ otpValues: newOtpValues, otpMessage: '' }, () => {
            const lastIndex = Math.min(pasted.length, 6) - 1;
            if (lastIndex >= 0 && this.otpInputRefs[lastIndex]) {
                this.otpInputRefs[lastIndex].focus();
            }
        });
    };

    handleResendOtp = async () => {
        const { mobile, otpTimerId, actionid } = this.state;

        if (otpTimerId) {
            clearInterval(otpTimerId);
        }

        // #region "call API Get OTP"
        const data = await this.callApiSR20OtpStep01(mobile, actionid, "Register", "3rd", "");

        if (data) {
            if (data.responseCode == "OK") {
                this.setState(
                    {
                        showOtpModal: true,
                        otpValues: ['', '', '', '', '', ''],
                        otpTimeLeft: 60,
                        otpCanResend: false,
                        otpMessage: '',
                        otpRefCode: data.returnObj.refCode,
                        otpRunId: data.returnObj.otpId,
                        otpMaxError: false,
                        registerMsgMobile: ''
                    },
                    () => {
                        this.startOtpTimer();

                        if (this.otpInputRefs[0]) {
                            this.otpInputRefs[0].focus();
                        }
                    }
                );
            } else {
                this.setState({ otpMessage: data.responseMessage });
            }
        } else {
            this.setState({ otpMessage: 'An unexpected error occurred on the server. Please try again.' });
        }
        // #endregion
    };

    handleVerifyOtp = async () => {
        const { otpRunId, otpRefCode, otpValues, otpTimerId } = this.state;
        const otpCode = otpValues.join("");

        if (otpCode.length !== 6) {
            this.setState(
                { otpMessage: "รหัส OTP ไม่ถูกต้อง / Invalid OTP" },
                () => this.chkEnableBtnSubmit()
            );
            return;
        }

        try {
            // #region "call API Verify OTP"
            const data = await this.callApiSR20OtpStep02("", "", "Register", "3rd", "", otpRunId, otpRefCode, otpCode);

            if (data) {
                if (data.responseCode === "OK") {
                    if (otpTimerId) {
                        clearInterval(otpTimerId);
                    }

                    this.setState({
                        otpMessage: '',
                        showOtpModal: false,
                        otpTimerId: null,
                        mobileVerified: true,
                        otpMaxError: false
                    },
                        () => this.chkEnableBtnSubmit());
                } else {
                    if (data.responseCode === "ErrorMax") {
                        this.setState({ otpMessage: data.responseMessage, otpMaxError: true },
                            () => this.chkEnableBtnSubmit());
                    }
                    else {
                        this.setState(
                            {
                                otpMessage: data.responseMessage,
                                otpMaxError: false
                            },
                            () => this.chkEnableBtnSubmit()
                        );
                    }
                    return;
                }
            } else {
                this.setState({ otpMessage: 'Invalid OTP' },
                    () => this.chkEnableBtnSubmit());
                return;
            }
            // #endregion
        } catch (error) {
            console.error('Verify OTP error:', error);
            this.setState({ otpMessage: 'Verify OTP failed' },
                () => this.chkEnableBtnSubmit());
        }
    };

    chkEnableBtnSubmit = () => {
        const { Terms01, cssBtnSubmit01, cssBtnSubmit02 } = this.state;

        let disabledBtnSubmit = false;
        let cssBtnSubmitCurrent = cssBtnSubmit02;

        // check agree1
        if (Terms01 === false) {
            disabledBtnSubmit = true;
            cssBtnSubmitCurrent = cssBtnSubmit01;
        }

        this.setState({
            disabledBtnSubmit: disabledBtnSubmit,
            cssBtnSubmitCurrent: cssBtnSubmitCurrent
        });
    };

    render() {
        const {
            submitting,
            email,
            Password,
            ConfirmPassword,
            registerMsgPwd, registerMsgPwd2, registerMsgFname, registerMsgLname, registerMsgMobile,
            Salutation,
            Name,
            Lastname,
            NameTH,
            LastnameTH,
            mobile,
            BirthdayD,
            BirthdayM,
            Terms01,
            Terms02,
            showPassword,
            showConfirmPassword,
            showPasswordHint,
            showBirthdayModal,
            isLoading,
            loginstatus,
            currentStep, disabledBtnOtp, disabledBtnSubmit, languagePreference, receiveNews, receiveNewsSMS, receiveNewsEmail, receiveNewsCss, showOtpModal, otpValues, otpTimeLeft, otpCanResend, otpRefCode, otpMessage, mobileVerified, otpMaxError, registerMsgLanguage, registerMsgReceive, registerMsgAgree, showPopup, cssBtnOtpCurrent, cssBtnSubmitCurrent, cssEmailUsername
        } = this.state;

        if (isLoading) {
            // while loading
            return (
                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                    <h3 className="text-black">LOADING ...</h3>
                    <img src="media/loading-gif.gif" alt="Loading..." width={80} className="img-fluid" />
                </div>
            );
        }

        return (
            <>
                <ZPartnerLSC0Header />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* #region Step01 */}
                    {currentStep === "1" && (
                        <section className="section-create-account overflow-hidden pb-5">
                            <div className="container p-3 p-md-0">
                                <div className="row">
                                    <div className="col-md-12 mb-5 pt-3 text-start">
                                        <h2 className="h3 mt-5 mb-4 fw-bold text-dark-212121">
                                            ลงทะเบียน<br />
                                            Create an account
                                        </h2>
                                        <form className="form-sr">
                                            <div className="row">
                                                <div className="col-md-4 mb-4">
                                                    <label className="form-label d-none">Username.</label>
                                                    <h5 className={cssEmailUsername}>{email}</h5>
                                                    <div className="form-text">ชื่อบัญชีสมาชิกของคุณ / This will be your username.</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">รหัสผ่าน<span className="text-green-1">*</span> / Enter your password<span className="text-green-1">*</span></label>
                                                    <div className="input-group mb-3">
                                                        <div className="input-group mb-3">
                                                            <input
                                                                type={showPassword ? "text" : "password"}
                                                                className="form-control border-end-0"
                                                                placeholder="รหัสผ่าน / Password"
                                                                name="Password"
                                                                value={Password}
                                                                onChange={this.handleChange}
                                                                onFocus={this.handlePasswordFocus}
                                                                onBlur={this.handlePasswordBlur}
                                                            />
                                                            <span className="input-group-text">
                                                                <i
                                                                    className={
                                                                        showPassword ? "fa fa-fw fa-eye toggle-password" : "fa fa-fw fa-eye-slash toggle-password"
                                                                    }
                                                                    onClick={this.togglePasswordVisibility}
                                                                ></i>
                                                            </span>
                                                            <div className="invalid-feedback" style={{ display: 'block' }}>{registerMsgPwd}</div>
                                                            {showPasswordHint && (
                                                                <div id="new-password-field-tips" className="passwordtips-box">
                                                                    <h4 className="h6 text-decoration-underline">Password Tips</h4>
                                                                    <p className="form-text">
                                                                        ความยาวรหัสตั้งแต่ 9 ถึง 15 ตัวอักษร <br />
                                                                        Between 9 to 15 characters <br />
                                                                        ประกอบด้วยตัวเลขอย่างน้อยหนึ่งตัว <br />
                                                                        At least one numeric character <br />
                                                                        ประกอบด้วยตัวอักษรพิมพ์ใหญ่อย่างน้อยหนึ่งตัว <br />
                                                                        At least one uppercase character <br />
                                                                        ประกอบด้วยตัวอักษรพิมพ์เล็กอย่างน้อยหนึ่งตัว <br />
                                                                        At least one lowercase character <br />
                                                                        ประกอบด้วยอักขระพิเศษอย่างน้อยหนึ่งตัว ดังนี้ ~!@()#$%^*:; <br />
                                                                        At least one special character ~!@()#$%^*:; <br />
                                                                        ไม่มีเว้นวรรค <br />
                                                                        No blank space
                                                                    </p>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label">ยืนยันรหัสผ่าน<span className="text-green-1">*</span> / Confirm Password<span className="text-green-1">*</span></label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            type={showConfirmPassword ? "text" : "password"}
                                                            className="form-control border-end-0"
                                                            placeholder="ยืนยันรหัสผ่าน / Confirm Password"
                                                            name="ConfirmPassword"
                                                            value={ConfirmPassword}
                                                            onChange={this.handleChange}
                                                        />
                                                        <span className="input-group-text">
                                                            <i
                                                                className={
                                                                    showConfirmPassword ? "fa fa-fw fa-eye toggle-password" : "fa fa-fw fa-eye-slash toggle-password"
                                                                }
                                                                onClick={this.toggleConfirmPasswordVisibility}
                                                            ></i>
                                                        </span>
                                                        <div className="invalid-feedback" style={{ display: 'block' }}>{registerMsgPwd2}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-start mt-4">
                                                <button type="button" className="btn btn-primary rounded-pill px-4 text-decoration-none" onClick={this.handleStep01}>ต่อไป / Continue</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </section>
                    )}
                    {/* #endregion */}

                    {/* #region Step02 */}
                    {currentStep === "2" && (
                        <section className="section-create-account overflow-hidden pb-5">
                            <div className="container p-3 p-md-0">
                                <div className="row">
                                    <div className="col-md-12 mb-5 pt-3 text-start">
                                        <h2 className="h3 mt-5 mb-4 fw-bold text-dark-212121">
                                            ลงทะเบียน<br />
                                            Create an account
                                        </h2>
                                        <form className="form-sr" autoComplete="off">
                                            <div className="row">
                                                <div className="col-md-4 mb-4">
                                                    <label className="form-label d-none">Username.</label>
                                                    <h5 className={cssEmailUsername}>{email}</h5>
                                                    <div className="form-text">ชื่อบัญชีสมาชิกของคุณ / This will be your username.</div>
                                                </div>
                                            </div>
                                            <h4 className="h4 mt-4 mb-3">
                                                <strong>
                                                    ข้อมูลของคุณ<br />
                                                    Personal Particulars
                                                </strong>
                                            </h4>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor="Salutation" className="form-label">คำนำหน้าชื่อ/PREFIX (OPTIONAL)</label>
                                                    <select
                                                        className="form-select"
                                                        name="Salutation"
                                                        value={Salutation}
                                                        onChange={this.handleChange}
                                                    >
                                                        <option value="">
                                                            กรุณาเลือก / Please select
                                                        </option>
                                                        <option value="Mr.">นาย / Mr.</option>
                                                        <option value="Mrs.">นาง / Mrs.</option>
                                                        <option value="Ms">นางสาว / Ms.</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label d-none">ชื่อ(ภาษาอังกฤษ)/Name (English)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="ชื่อ(ภาษาอังกฤษ)/Name (English)"
                                                        name="Name"
                                                        maxLength={30}
                                                        value={Name}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div className="text-start mt-1 text-alert-2">
                                                        {registerMsgFname}
                                                    </div>
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label d-none">นามสกุล(ภาษาอังกฤษ)/Last Name (English)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="นามสกุล(ภาษาอังกฤษ)/Last Name (English)"
                                                        name="Lastname"
                                                        maxLength={30}
                                                        value={Lastname}
                                                        onChange={this.handleChange}
                                                    />
                                                    <div className="text-start mt-1 text-alert-2">
                                                        {registerMsgLname}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label d-none">ชื่อ (ภาษาไทย) (optional)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="ชื่อ (ภาษาไทย) (optional)"
                                                        name="NameTH"
                                                        maxLength={30}
                                                        value={NameTH}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                                <div className="col-md-4 mb-3">
                                                    <label className="form-label d-none">นามสกุล (ภาษาไทย) (optional)</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="นามสกุล (ภาษาไทย) (optional)"
                                                        name="LastnameTH"
                                                        maxLength={30}
                                                        value={LastnameTH}
                                                        onChange={this.handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <p className="h6">วันเกิด (ไม่จำเป็นต้องระบุ) / Birthday (optional)<br />
                                                        <span className="small">คุณจะได้รับสิทธิพิเศษ ในเดือนเกิดของคุณเมื่อคุณปรับระดับเป็น Gold / Make your birthday special once you reach Gold level with a reward on us.</span></p>
                                                    <div className="row g-3">
                                                        <div className="col-md-3 mb-3">
                                                            <select
                                                                className="form-select"
                                                                name="BirthdayM"
                                                                value={BirthdayM}
                                                                onChange={this.handleChange}
                                                            >
                                                                <option value="">เดือน /  Month</option>
                                                                <option value="01">ม.ค. / Jan</option>
                                                                <option value="02">ก.พ. / Feb</option>
                                                                <option value="03">มี.ค. / Mar</option>
                                                                <option value="04">เม.ษ. / Apr</option>
                                                                <option value="05">พ.ค. / May</option>
                                                                <option value="06">มิ.ย. / Jun</option>
                                                                <option value="07">ก.ค. / Jul</option>
                                                                <option value="08">ส.ค. / Aug</option>
                                                                <option value="09">ก.ย. / Sep</option>
                                                                <option value="10">ต.ค. / Oct</option>
                                                                <option value="11">พ.ย. / Nov</option>
                                                                <option value="12">ธ.ค. / Dec</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-3 mb-3">
                                                            <select
                                                                className="form-select"
                                                                name="BirthdayD"
                                                                value={BirthdayD}
                                                                onChange={this.handleChange}
                                                            >
                                                                <option value="">วัน / Day</option>
                                                                {Array.from({ length: 31 }).map(
                                                                    (_, i) => (
                                                                        <option key={i + 1} value={i + 1}>
                                                                            {i + 1}
                                                                        </option>
                                                                    )
                                                                )}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-12 col-md-4 mb-3">
                                                    <label className="form-label">เบอร์โทรศัพท์<span className="text-green-1">*</span> / Mobile Number <span className="text-green-1">*</span></label>
                                                    <div className="input-group mb-3">
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            className={`form-control rounded ${mobileVerified ? 'is-valid' : ''}`}
                                                            name="mobile"
                                                            value={mobile}
                                                            onChange={this.handleChange}
                                                            maxLength={10}
                                                            readOnly={mobileVerified}
                                                            autoComplete="block-auto-mobile"
                                                        />

                                                        {!mobileVerified && (
                                                            <button
                                                                type="button"
                                                                className={cssBtnOtpCurrent}
                                                                disabled={disabledBtnOtp}
                                                                onClick={this.openOtpModal}
                                                            >
                                                                Get OTP / รับรหัส OTP
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <div className="text-start mt-1 text-alert-2">
                                                        {registerMsgMobile}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mb-3">
                                                    <hr className="mt-2 mb-3" />
                                                </div>
                                            </div>

                                            <div className="row form-check-term">
                                                <div className="col-md-12 mb-3">
                                                    <p className="fw-bold mb-3">
                                                        <label className="form-label fw-medium d-block mb-3 fs-6">
                                                            <strong>การตั้งค่าและเงื่อนไข / Preference &amp; Terms</strong>
                                                        </label>
                                                    </p>

                                                    {/* Language Preference (RADIO) */}
                                                    <div className="mb-3">
                                                        <label className="form-label fw-medium d-block">
                                                            ภาษาที่ต้องการสำหรับรับข้อมูลข่าวสาร<span className="text-green-1">*</span> / Preferred language for communication updates <span className="text-green-1">*</span>
                                                        </label>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input lang-radio"
                                                                type="radio"
                                                                name="languagePreference"
                                                                id="lang-en"
                                                                value="en"
                                                                checked={this.state.languagePreference === "en"}
                                                                onChange={this.handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor="lang-en">English</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input lang-radio"
                                                                type="radio"
                                                                name="languagePreference"
                                                                id="lang-th"
                                                                value="th"
                                                                checked={this.state.languagePreference === "th"}
                                                                onChange={this.handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor="lang-th">ไทย</label>
                                                        </div>
                                                        <div className="text-danger mt-1 fs-6" id="lang-error">
                                                            {registerMsgLanguage}
                                                        </div>
                                                    </div>

                                                    {/* Sign up promotions */}
                                                    <div className="mb-3">
                                                        <div className="form-check d-flex">
                                                            <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNews" checked={receiveNews}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label d-block d-md-inline" htmlFor="promo-checkbox">
                                                                สมัครเพื่อรับโปรโมชันและข่าวสารพิเศษจากสตาร์บัคส์<span className="text-green-1">*</span> / Sign up to receive exclusive Starbucks promotions and news.<span className="text-green-1">*</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    {/* Preferred channel */}
                                                    <div className={receiveNewsCss}>
                                                        <p className="fw-normal mb-2 fs-6">ฉันต้องการรับข้อมูลข่าวสารผ่าน: / I prefer to receive updates via:</p>
                                                        <div className="form-check form-check-inline">
                                                            <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNewsEmail" checked={receiveNewsEmail}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label" htmlFor="channel-email">อีเมล / Email</label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input type="checkbox" className="form-check-input channel-checkbox" name="receiveNewsSMS" checked={receiveNewsSMS}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label" htmlFor="channel-sms">SMS</label>
                                                        </div>
                                                        <div className="text-danger mt-1 fs-6">
                                                            {registerMsgReceive}
                                                        </div>
                                                    </div>

                                                    {/* Agree terms */}
                                                    <div className="mb-4">
                                                        <div className="form-check d-flex">
                                                            <input type="checkbox" className="form-check-input" name="Terms01" checked={Terms01}
                                                                onChange={this.handleChange} />
                                                            <label className="form-check-label d-block d-md-inline" htmlFor="agree-terms">
                                                                ฉันยอมรับ <a href="https://starbucks.co.th/th/online-policies/privacy-notice/" target="_blank">นโยบายความเป็นส่วนตัว</a>และ <a href="https://rewards.starbucks.co.th/thtermsofuse" target="_blank">ข้อกำหนดการใช้งาน</a> / I agree to the Starbucks <a href="https://www.starbucks.co.th/online-policies/privacy-notice/" target="_blank">Privacy Policy</a> and <a href="https://rewards.starbucks.co.th/termsofuse" target="_blank">Terms of Use</a>.
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="text-danger mt-1 fs-6">
                                                        {registerMsgAgree}
                                                    </div>
                                                    <p className="font-15px"><span className="text-green-1">*</span> คุณสามารถอัปเดตการตั้งค่าของคุณได้บนเว็บไซต์สตาร์บัคส์ ผ่านหน้าโปรไฟล์สมาชิก / You can update your preferences on the Starbucks website through your member profile page.</p>
                                                    {/* Submit */}
                                                    <button
                                                        className={cssBtnSubmitCurrent}
                                                        id="submit-btn"
                                                        disabled={disabledBtnSubmit}
                                                        onClick={this.handleSubmit}
                                                    >
                                                        ลงทะเบียน / Create an account
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>

                            {/*Modal OTP*/}
                            {showOtpModal && (
                                <>
                                    <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog modal-fullscreen">
                                            <div className="modal-content justify-content-center">
                                                <div className="container">
                                                    <div className="row justify-content-center">
                                                        <div className="col-12 col-md-6">
                                                            <div className="modal-header border-bottom-0">
                                                                <h1 className="modal-title fs-5">กรอกรหัสยืนยัน / Enter Verification Code</h1>
                                                                <button
                                                                    type="button"
                                                                    className="btn-close"
                                                                    onClick={this.closeOtpModal}
                                                                ></button>
                                                            </div>

                                                            <div className="modal-body">
                                                                <p className="text-decoration-none">กรุณาใส่รหัสยืนยัน 6 หลักที่ส่งไปยัง / Please enter the 6-digit code sent to {mobile}</p>

                                                                <div className="row g-2 mb-3">
                                                                    <div className="col-auto d-flex gap-2">
                                                                        {otpValues.map((value, index) => (
                                                                            <input
                                                                                key={index}
                                                                                ref={(el) => (this.otpInputRefs[index] = el)}
                                                                                type="text"
                                                                                inputMode="numeric"
                                                                                pattern="[0-9]*"
                                                                                autoComplete={index === 0 ? "one-time-code" : "off"}
                                                                                maxLength="1"
                                                                                className="form-control form-control-lg text-center rounded-2 px-2 py-3 otp-input"
                                                                                style={{ width: '56px' }}
                                                                                value={value}
                                                                                onChange={(e) => this.handleOtpChange(index, e)}
                                                                                onKeyDown={(e) => this.handleOtpKeyDown(index, e)}
                                                                                onPaste={this.handleOtpPaste}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>

                                                                <p className="fw-medium">
                                                                    Ref. Code: <span className="text-green-1">{otpRefCode}</span>
                                                                </p>

                                                                {otpMessage && (
                                                                    <p className="text-alert-2">{otpMessage}</p>
                                                                )}

                                                                {!otpCanResend ? (
                                                                    <p className="fw-medium">
                                                                        {!otpMaxError && (
                                                                            <>
                                                                                ส่งรหัสอีกครั้งใน / Resend code in{" "}
                                                                                <span className="text-muted">
                                                                                    <strong>{this.formatOtpTime(otpTimeLeft)}</strong>
                                                                                </span>
                                                                            </>
                                                                        )}

                                                                    </p>
                                                                ) : (
                                                                    <p>
                                                                        {!otpMaxError && (
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-link p-0 fw-medium text-green-1 text-decoration-underline"
                                                                                onClick={this.handleResendOtp}
                                                                            >
                                                                                ส่งรหัสอีกครั้ง / Resend code
                                                                            </button>
                                                                        )}
                                                                    </p>
                                                                )}

                                                                <div className="mt-4 d-flex gap-2">
                                                                    {!otpMaxError && (
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-primary rounded-pill px-4"
                                                                            onClick={this.handleVerifyOtp}
                                                                        >
                                                                            ตรวจสอบ OTP / Verify OTP
                                                                        </button>
                                                                    )}

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-secondary rounded-pill px-4 d-none"
                                                                        onClick={this.closeOtpModal}
                                                                    >
                                                                        ปิด / Close
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-backdrop fade show"></div>
                                </>
                            )}

                            {showBirthdayModal && (
                                <div>
                                    <div className="modal fade show d-block" id="BirthdayModal" tabIndex={-1}>
                                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">

                                            <div className="modal-content">

                                                {/* Header */}
                                                <div className="modal-header border-bottom-0">
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        onClick={this.closeBirthdayModal}
                                                    />
                                                </div>

                                                {/* Body */}
                                                <div className="modal-body px-3 text-center">
                                                    <h3 className="text-green-1 fw-bold">
                                                        คุณจะพลาดสิทธิพิเศษในวันเกิด? / You’ll miss birthday reward?
                                                    </h3>

                                                    <h5 className="fw-bold lh-base">
                                                        Birthday rewards are one of the perks for Gold level members.
                                                        Are you sure you want to leave your birthday blank?<br />

                                                        เพื่อไม่ให้พลาดรับสิทธิพิเศษในวันเกิด <br />
                                                        เมื่อคุณได้ปรับระดับเป็น Gold <br />
                                                        กรุณาใส่วันและเดือนเกิดของคุณ
                                                    </h5>
                                                </div>

                                                {/* Footer */}
                                                <div className="modal-footer border-top-0 justify-content-center mb-4">

                                                    <button
                                                        type="button"
                                                        className="btn btn-primary rounded-5 px-4 d-block"
                                                        style={{ minWidth: "86px" }}
                                                        onClick={this.confirmSkipBirthday}
                                                    >
                                                        ใช่ / Yes
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary rounded-5 px-4"
                                                        style={{ minWidth: "86px" }}
                                                        onClick={this.goFillBirthday}
                                                    >
                                                        ไม่ใช่ / No
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </section>

                    )}
                    {/* #endregion */}
                </main>

                <ZPartnerLSC0Footer />
            </>

        );
    }
}
